export default {
  seo: {
    home: {
      title: "IGNIVA — Superfícies e soluções para arquitetura e interiores",
      desc: "A IGNIVA seleciona e representa marcas internacionais de materiais, superfícies e tecnologia para arquitetura e interiores. Lithotech em distribuição exclusiva em Portugal pela IGNIVA.",
    },
    about: {
      title: "A IGNIVA — Curadoria, apoio técnico e acompanhamento comercial | IGNIVA",
      desc: "A IGNIVA seleciona marcas e materiais, apoia a especificação e acompanha arquitetos, designers, lojas de cozinhas e banho, marmoristas e fabricantes de mobiliário.",
    },
    brands: {
      title: "Marcas e soluções | IGNIVA",
      desc: "Lithotech, Foster e Mastercharge: superfícies de grande formato, equipamento de cozinha e carregamento sem fios integrado.",
    },
    applications: {
      title: "Aplicações — Cozinhas, casas de banho, mobiliário e revestimentos | IGNIVA",
      desc: "Aplicações em cozinhas, casas de banho, mobiliário, revestimentos, fachadas e tecnologia integrada, com as marcas apresentadas pela IGNIVA.",
    },
    explorer: {
      title: "Explorar soluções | IGNIVA",
      desc: "Descubra superfícies e soluções por marca, aplicação e característica, e peça informação com o contexto já definido.",
    },
    professionals: {
      title: "Profissionais — Arquitetos, designers, cozinhas e banho | IGNIVA",
      desc: "Informação, documentação oficial e apoio à especificação para arquitetos, designers, lojas de cozinhas e banho, marmoristas e fabricantes de mobiliário.",
    },
    contacts: {
      title: "Contactos | IGNIVA",
      desc: "Fale-nos do seu projeto: informação de produto, amostras, documentação ou orçamento.",
    },
    quote: {
      title: "Pedido de orçamento | IGNIVA",
      desc: "Peça um orçamento: marca, aplicação e detalhes do projeto. Os valores dependem da validação de medidas, materiais e detalhes técnicos.",
    },
    privacy: {
      title: "Política de privacidade | IGNIVA",
      desc: "Como a IGNIVA trata os dados pessoais recolhidos através deste site.",
    },
    legal: { title: "Informação legal | IGNIVA", desc: "Identificação da IGNIVA Design & Surface Solutions, Unipessoal Lda." },
  },
  nav: {
    home: "Início",
    about: "A IGNIVA",
    brands: "Marcas",
    applications: "Aplicações",
    explorer: "Explorar soluções",
    professionals: "Profissionais",
    contacts: "Contactos",
    quote: "Pedir orçamento",
    menu_open: "Abrir menu",
    menu_close: "Fechar menu",
  },
  common: {
    all: "Todas",
    all_m: "Todos",
    explore: "Explorar",
    request_info: "Pedir informação",
    request_quote: "Pedir orçamento",
    next: "Seguinte",
    back: "Voltar",
    submit: "Enviar pedido",
    sending: "A enviar…",
    close: "Fechar",
    official_site: "Site oficial da marca",
    catalogue: "Catálogos e documentação",
    catalogue_note: "Catálogos, fichas técnicas e amostras dependem de cada marca. Fale com a IGNIVA para saber o que está disponível.",
    applications: "Aplicações",
    brand: "Marca",
    aesthetic: "Característica",
    step: "Passo",
    of: "de",
    origin: "Origem",
    scopes: "Aplicações",
    back_brands: "Voltar às marcas",
    gallery: "Aplicações e inspiração",
    categories: "Produtos e soluções",
    video: "Vídeo oficial",
    video_hint: "Reproduzir o vídeo oficial da marca (YouTube)",
    video_note: "Ao reproduzir, o vídeo é carregado a partir do YouTube, que pode guardar cookies no seu navegador.",
    docs: "Documentação oficial",
    image_note: "Fotografias oficiais da marca, usadas como aplicação ou inspiração. Não correspondem a projetos realizados pela IGNIVA.",
    pending_image: "Imagem oficial em breve",
    brands_label: "Marcas",
    exclusive_pt: "Distribuição exclusiva em Portugal pela IGNIVA",
    know_brand: "Conhecer {name}",
  },
  home: {
    tag: "Arquitetura · Interiores · Superfícies",
    h1a: "Superfícies e soluções",
    h1b: "para projetos com identidade.",
    intro: "A IGNIVA seleciona e representa marcas internacionais de materiais, superfícies e tecnologia para arquitetura e interiores.",
    cta1: "Conhecer as marcas",
    cta2: "Fale-nos do seu projeto",
    slides: [
      { a: "Cozinhas", b: "Lithotech — composição de cozinha" },
      { a: "Bancadas", b: "Lithotech — detalhe de bancada" },
      { a: "Superfícies", b: "Lithotech — acabamento de superfície" },
    ],
    trust: [
      "Seleção criteriosa de marcas e materiais",
      "Apoio técnico e à especificação",
      "Ligação entre fabricantes e profissionais",
    ],
    scroll: "Deslize para descobrir",
    manifesto_tag: "O que fazemos",
    manifesto_title: "Entre quem fabrica e quem projeta.",
    manifesto_text: [
      "A IGNIVA aproxima marcas internacionais dos profissionais de arquitetura e interiores.",
      "Selecionamos materiais e soluções pela sua qualidade, desenho e desempenho técnico, apoiando arquitetos, designers, lojas de cozinhas, fabricantes e transformadores na sua integração em cada projeto.",
      "A nossa atividade combina conhecimento dos materiais, apoio à especificação e acompanhamento comercial.",
    ],
    manifesto_cta: "Conhecer a IGNIVA",
    roles: [
      {
        t: "Seleção",
        d: "Selecionamos marcas e materiais pela qualidade estética, pelo desempenho técnico e pelas possibilidades de aplicação.",
      },
      {
        t: "Apoio à especificação",
        d: "Apoiamos os profissionais na escolha de materiais e soluções, disponibilizando informação técnica e documentação oficial dos fabricantes.",
      },
      {
        t: "Acompanhamento comercial",
        d: "Fazemos a ligação entre fabricantes e profissionais, acompanhando os pedidos de informação, a especificação e o desenvolvimento de oportunidades.",
      },
    ],
    sectors_tag: "Para quem",
    sectors: ["Arquitetura", "Design de interiores", "Cozinhas e banho", "Marmoristas", "Mobiliário", "Promotores"],
    brands_tag: "Marcas",
    brands_title: "Marcas e soluções",
    brands_sub: "Marcas internacionais com propostas distintas para arquitetura, interiores e mobiliário. Materiais, equipamentos e tecnologia selecionados pelas suas características e possibilidades de aplicação.",
    apps_tag: "Aplicações",
    apps_title: "Onde cada solução se aplica.",
    apps_cta: "Ver todas as aplicações",
    explorer_tag: "Descoberta",
    explorer_title: "Explorar soluções",
    explorer_text: "Descubra materiais e soluções por marca, aplicação e características, e encontre a informação mais relevante para o seu projeto.",
    explorer_cta: "Abrir explorador",
    cta_title: "Fale-nos do seu projeto.",
    cta_text: [
      "Procura informações sobre materiais, equipamentos ou soluções para um projeto?",
      "Contacte-nos para solicitar documentação técnica, amostras ou um orçamento.",
    ],
    intro2: "Apoiamos arquitetos, designers e outros profissionais na escolha e especificação de soluções para cozinhas, casas de banho, mobiliário e revestimentos.",
    apps_intro: "Materiais, equipamentos e tecnologia para diferentes espaços e necessidades de projeto.",
  },
  about: {
    tag: "A IGNIVA",
    title: "Entre quem fabrica e quem projeta.",
    lead: "A IGNIVA faz a curadoria de superfícies e soluções para arquitetura e interiores, com apoio técnico e comercial próximo dos profissionais. Selecionamos marcas e materiais, ajudamos a especificar e acompanhamos cada pedido de perto.",
    experience: "A empresa assenta na experiência do fundador no setor da pedra e das superfícies, com percurso em gestão comercial, desenvolvimento de mercados e acompanhamento de redes profissionais.",
    note: "A IGNIVA não é fabricante nem instaladora.",
    note_text: "As características dos produtos pertencem a cada marca e constam da sua documentação oficial. À IGNIVA cabe a seleção, o apoio à especificação e o acompanhamento comercial.",
    pillars_tag: "Como trabalhamos",
    pillars_title: "Três formas de apoiar o seu projeto.",
    pillars: [
      {
        n: "01",
        t: "Seleção",
        d: "Escolhemos marcas e materiais pela qualidade estética e técnica e pela forma como se integram nos projetos.",
      },
      {
        n: "02",
        t: "Apoio à especificação",
        d: "Ajudamos a perceber o material, as aplicações e a documentação oficial de cada marca, para que a escolha seja informada.",
      },
      {
        n: "03",
        t: "Acompanhamento comercial",
        d: "Fazemos a ligação entre as marcas e os profissionais, com um contacto próximo desde o primeiro pedido de informação.",
      },
    ],
    rel_tag: "Para quem",
    rel_title: "Quem acompanhamos.",
    rel_text: "Arquitetos e designers de interiores, lojas e estúdios de cozinhas e banho, marmoristas e empresas de transformação, fabricantes de mobiliário e promotores de projetos residenciais, comerciais e de Hospitality. Falamos a linguagem técnica de quem especifica, de forma clara para quem decide.",
    cta: "Fale-nos do seu projeto",
  },
  brands_page: {
    tag: "Marcas",
    title: "Marcas e soluções",
    sub: "Marcas internacionais com propostas distintas para arquitetura, interiores e mobiliário. Materiais, equipamentos e tecnologia selecionados pelas suas características e possibilidades de aplicação.",
    filter_all: "Todas",
    cta: "Ver marca",
  },
  brand: {
    lithotech: {
      tag: "Pedra sinterizada",
      origin: "Castellón, Espanha",
      headline: "Superfícies de grande formato.",
      categories: ["Bancadas de cozinha", "Casas de banho", "Mobiliário", "Revestimentos"],
      short: "Superfícies de pedra sinterizada de grande formato para bancadas, revestimentos, mobiliário e outras aplicações arquitetónicas. Uma seleção de cores, texturas e acabamentos que combina expressão estética, desempenho técnico e versatilidade de aplicação.",
      long: [
        "A Lithotech é uma marca espanhola de pedra sinterizada, com sede e produção em Castellón. As suas coleções incluem Frame, Oda, Gubi e Allure, entre outras.",
        "A marca desenvolve tecnologia própria, como a Corelith® e a 3D·Fit®, para superfícies com relevo e sinterização controlada. As coleções Frame, Oda e Gubi recorrem à 3D·Fit® para fazer coincidir o padrão com o relevo da superfície.",
        "A IGNIVA assegura a distribuição exclusiva da Lithotech em Portugal. Formatos, espessuras, acabamentos e características técnicas de cada coleção constam do catálogo e das fichas técnicas oficiais.",
      ],
      ambitos: ["Bancadas de cozinha", "Casas de banho", "Mobiliário", "Revestimentos"],
      desc: [
        "Superfícies de pedra sinterizada de grande formato para bancadas, revestimentos, mobiliário e outras aplicações arquitetónicas.",
        "Uma seleção de cores, texturas e acabamentos que combina expressão estética, desempenho técnico e versatilidade de aplicação.",
      ],
    },
    foster: {
      tag: "Equipamentos para cozinha",
      origin: "Brescello, Itália",
      headline: "Lava-louças e torneiras para a cozinha.",
      categories: ["Lava-louças", "Torneiras"],
      short: "Equipamentos de cozinha em aço inoxidável, desenvolvidos com especial atenção ao desenho, à funcionalidade e à integração nos espaços. Lava-louças, torneiras, placas e outras soluções que combinam tecnologia e design italiano.",
      long: [
        "A Foster é uma empresa italiana fundada em 1973, com sede em Brescello e quatro unidades de produção. Trabalha o aço inoxidável (AISI 304 e AISI 316) em lava-louças, torneiras e outros equipamentos de cozinha.",
        "Entre os acabamentos da marca contam-se o aço satinado e as cores PVD, como Gun Metal, Gold e Copper. Para informação sobre gamas e acabamentos, fale com a IGNIVA ou consulte o site oficial da marca.",
      ],
      ambitos: ["Cozinhas"],
      desc: [
        "Equipamentos de cozinha em aço inoxidável, desenvolvidos com especial atenção ao desenho, à funcionalidade e à integração nos espaços.",
        "Lava-louças, torneiras, placas e outras soluções que combinam tecnologia e design italiano.",
      ],
    },
    mastercharge: {
      tag: "Carregamento sem fios integrado",
      origin: "Reino Unido",
      headline: "O telemóvel carrega ao pousar sobre a bancada.",
      categories: ["Carregamento sob bancadas", "Carregamento em mobiliário e mesas"],
      short: "Tecnologia de carregamento sem fios integrada sob superfícies compatíveis, permitindo carregar dispositivos sem carregadores ou cabos visíveis sobre a bancada. Uma solução discreta para cozinhas, mesas e mobiliário, que acrescenta funcionalidade sem comprometer o desenho.",
      long: [
        "A Mastercharge desenvolve carregadores sem fios (Qi) para instalar por baixo de bancadas, mesas e mobiliário, sem elementos à vista. Basta pousar o telemóvel sobre a superfície para começar a carregar.",
        "O carregamento atravessa materiais como madeira, pedra e vidro, mas não funciona através de metal. A distância máxima, a potência e a compatibilidade dependem do modelo e do material: consulte o manual oficial e fale com a IGNIVA antes de especificar.",
      ],
      ambitos: ["Bancadas de cozinha", "Mobiliário e mesas"],
      desc: [
        "Tecnologia de carregamento sem fios integrada sob superfícies compatíveis, permitindo carregar dispositivos sem carregadores ou cabos visíveis sobre a bancada.",
        "Uma solução discreta para cozinhas, mesas e mobiliário, que acrescenta funcionalidade sem comprometer o desenho.",
      ],
    },
  },
  apps_page: {
    tag: "Aplicações",
    title: "Onde cada solução se aplica.",
    sub: "Escolha uma aplicação para ver as marcas e as soluções correspondentes. As imagens são fotografias oficiais das marcas, usadas como aplicação ou inspiração.",
    brands_for: "Marcas para esta aplicação",
  },
  app_items: {
    cozinhas: "Cozinhas",
    banhos: "Casas de banho",
    mobiliario: "Mobiliário",
    revestimentos: "Revestimentos",
    fachadas: "Fachadas",
    integrada: "Tecnologia integrada",
  },
  app_cats: {
    cozinhas: "Cozinhas",
    banhos: "Casas de banho",
    mobiliario: "Mobiliário",
    revestimentos: "Revestimentos",
    fachadas: "Fachadas",
    integrada: "Tecnologia integrada",
  },
  categories: { superficies: "Superfícies", equipamento: "Equipamento de cozinha", tecnologia: "Tecnologia integrada" },
  explorer: {
    tag: "Descoberta",
    title: "Explorar soluções",
    sub: "Filtre por marca, categoria, aplicação e característica.",
    filter_brand: "Marca",
    filter_app: "Aplicação",
    filter_aes: "Característica",
    filter_cat: "Categoria",
    empty: "Nenhuma solução corresponde aos filtros selecionados.",
    detail_cta: "Pedir informação",
    detail_brand: "Marca",
  },
  explorer_items: {
    "lithotech-superficies": {
      name: "Superfícies Lithotech",
      desc: "Superfícies de grande formato para bancadas de cozinha, banho e mobiliário, de acordo com a documentação técnica de cada produto.",
    },
    "lithotech-revestimentos": {
      name: "Revestimentos de grande formato",
      desc: "Grande formato para revestimentos interiores, consoante o produto e a documentação oficial da marca.",
    },
    "foster-lava-loucas": { name: "Lava-louças Foster", desc: "Lava-louças em aço inoxidável para a cozinha." },
    "foster-torneiras": { name: "Torneiras Foster", desc: "Torneiras para a cozinha, com diferentes acabamentos." },
    "mastercharge-carregamento": {
      name: "Carregamento sem fios integrado",
      desc: "Carregamento sem fios integrado em bancadas, mesas e mobiliário. A compatibilidade depende da documentação técnica da marca.",
    },
  },
  aesthetics: { pedra: "Pedra", aco: "Aço inoxidável", integrado: "Integrado", grande_formato: "Grande formato" },
  quote: {
    tag: "Orçamento",
    title: "Pedido de orçamento",
    sub: "Quatro passos simples. Os valores dependem da validação de medidas, materiais e detalhes técnicos, por isso respondemos depois de analisar o seu pedido.",
    steps: ["Marca", "Aplicação", "Projeto", "Contactos"],
    s1_title: "Qual a marca pretendida?",
    s2_title: "Qual a aplicação?",
    s3_title: "Sobre o projeto",
    tipo: "Tipo de projeto",
    quantidade: "Quantidade estimada (m², unidades…)",
    localizacao: "Localização do projeto",
    tipos: {
      residencial: "Residencial",
      hospitality: "Hospitality",
      comercial: "Comercial",
      retalho: "Retalho",
      outro: "Outro",
    },
    files_hint: "Tem plantas ou ficheiros técnicos? Depois de enviar o pedido, envie-os para",
    s4_title: "Os seus contactos",
    review: "Resumo do pedido",
    new: "Novo pedido",
  },
  pros: {
    tag: "Profissionais",
    title: "Soluções para quem projeta e transforma.",
    sub: [
      "Trabalhamos com arquitetos, designers, lojas de cozinhas e banho, marmoristas, fabricantes de mobiliário e promotores.",
      "Disponibilizamos informação sobre materiais, documentação técnica e apoio comercial para facilitar a escolha e integração das soluções em cada projeto.",
    ],
    benefits_tag: "Como ajudamos",
    benefits_title: "Trabalhar com a IGNIVA",
    benefits: [
      "Seleção de marcas e materiais com critério",
      "Documentação oficial das marcas para apoiar a especificação",
      "Amostras, sempre que a marca as disponibilize",
      "Um interlocutor para pedidos de informação e de orçamento",
    ],
    res_tag: "Recursos",
    res_title: "Documentação por marca",
    res_note: "Catálogos, fichas técnicas e amostras dependem de cada marca. Pode consultar a documentação oficial pública ou pedir-nos informação.",
    res_site: "Site oficial",
    res_docs: "Catálogos e documentação",
    form_tag: "Contacto profissional",
    form_title: "Apresente-se à IGNIVA",
    tipo: "Perfil profissional",
    tipos: {
      arquiteto: "Arquiteto/a",
      designer: "Designer de interiores",
      estudio_cozinhas: "Loja ou estúdio de cozinhas e banho",
      marmorista: "Marmorista",
      fabricante: "Fabricante de mobiliário",
      promotor: "Promotor",
      outro: "Outro",
    },
    areas: [
      {
        t: "Informação técnica",
        d: "Acesso à documentação oficial dos fabricantes, características dos materiais e recomendações de aplicação.",
      },
      {
        t: "Amostras e materiais",
        d: "Apoio na identificação de referências e na solicitação de amostras para avaliação e especificação.",
      },
      {
        t: "Acompanhamento comercial",
        d: "Articulação com fabricantes e parceiros para responder a pedidos de informação e desenvolver oportunidades de projeto.",
      },
    ],
  },
  contact: {
    tag: "Contactos",
    title: "Fale-nos do seu projeto.",
    sub: "Informação de produto, amostras, documentação ou orçamento: diga-nos o que procura e respondemos por email.",
    assunto: "Tipo de pedido",
    assuntos: { info: "Informação", amostras: "Amostras", orcamento: "Orçamento", outro: "Outro" },
    email_label: "Email",
    phone_label: "Telefone",
    form_title: "Envie a sua mensagem",
  },
  form: {
    nome: "Nome",
    empresa: "Empresa",
    email: "Email",
    telefone: "Telefone (opcional)",
    atividade: "Atividade profissional",
    mensagem: "Mensagem",
    atividades: [
      "Arquitetura",
      "Design de interiores",
      "Loja ou estúdio de cozinhas e banho",
      "Marmorista ou transformação",
      "Fabricante de mobiliário",
      "Promotor ou projetos comerciais",
      "Cliente particular",
      "Outra",
    ],
    gdpr: "Autorizo o tratamento dos meus dados para responder a este pedido, nos termos da",
    gdpr_link: "Política de privacidade",
    send: "Enviar mensagem",
    required: "Campo obrigatório",
    success_title: "Obrigado pelo seu contacto.",
    success_text: "Recebemos o seu pedido e entraremos em contacto consigo com a maior brevidade possível.",
    error: "Não foi possível enviar o seu pedido. Por favor, tente novamente ou contacte-nos através de {email}.",
    another: "Enviar novo pedido",
  },
  privacy: {
    tag: "Privacidade",
    title: "Política de privacidade",
    updated: "Texto sujeito a validação final pela IGNIVA antes da publicação.",
    sections: [
      {
        h: "Quem é o responsável",
        p: [
          "O responsável pelo tratamento dos dados pessoais recolhidos neste site é a IGNIVA Design & Surface Solutions, Unipessoal Lda., NIF 518865983, com sede em Avenida dos Congressos da Oposição Democrática, Lote 5, 4.º B, 3800-365 Aveiro, Portugal.",
          "Pode contactar-nos através do email indicado na página de contactos.",
        ],
      },
      {
        h: "Que dados recolhemos",
        p: [
          "Apenas os dados que nos envia através dos formulários do site: nome, email, empresa, telefone (opcional), atividade profissional, tipo de pedido e o conteúdo da mensagem. No pedido de orçamento, recolhemos também a marca, a aplicação, o tipo de projeto, a quantidade e a localização do projeto, quando as indicar.",
        ],
      },
      {
        h: "Para que usamos os dados",
        p: [
          "Usamos os dados exclusivamente para responder ao seu pedido de informação, amostras ou orçamento. O fundamento é o seu consentimento, dado ao submeter o formulário, e as diligências prévias a um eventual contrato.",
          "Não usamos os dados para publicidade de terceiros nem os vendemos.",
        ],
      },
      {
        h: "Quem recebe os dados",
        p: [
          "As mensagens são entregues na caixa de correio da IGNIVA através de serviços técnicos de terceiros que as processam apenas para esse efeito: o Cloudflare, que aloja o site e recebe o pedido, e o Resend, que envia o email. Os dados não são guardados no site.",
        ],
      },
      {
        h: "Durante quanto tempo guardamos os dados",
        p: [
          "Pelo tempo necessário para responder ao pedido e para cumprir eventuais obrigações legais. Depois disso, os dados são eliminados.",
        ],
      },
      {
        h: "Os seus direitos",
        p: [
          "Pode pedir o acesso, a retificação, a eliminação ou a limitação do tratamento dos seus dados, opor-se ao tratamento e retirar o consentimento a qualquer momento, escrevendo para o nosso email. Tem também o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (www.cnpd.pt).",
        ],
      },
      {
        h: "Cookies e conteúdos de terceiros",
        p: [
          "Este site não usa cookies de publicidade nem ferramentas de análise ou de rastreio, e os tipos de letra estão alojados no próprio site.",
          "Alguns vídeos oficiais das marcas são do YouTube. Só são carregados quando carrega em reproduzir; nesse momento, o YouTube pode guardar cookies no seu navegador, de acordo com a sua própria política.",
        ],
      },
    ],
  },
  footer: {
    tagline: "Seleção e representação de marcas internacionais de materiais, superfícies e tecnologia para arquitetura e interiores.",
    nav: "Navegação",
    brands: "Marcas",
    contact: "Contacto",
    rights: "Todos os direitos reservados.",
    privacy: "Política de privacidade",
    legal_info: "Informação legal",
  },
  legal: {
    tag: "Informação legal",
    title: "Identificação do prestador",
    intro: "Informação disponibilizada nos termos do artigo 10.º do Decreto-Lei n.º 7/2004.",
    name: "Denominação social",
    nif: "NIF / NIPC",
    seat: "Sede",
    email: "Email",
  },
};
